import VideoOptions from "%/dynamic-component-editor/bundles/video-options";
import Autoplay from "%/dynamic-component-editor/options/autoplay";
import Controls from "%/dynamic-component-editor/options/controls";
import Muted from "%/dynamic-component-editor/options/muted";
import Poster from "%/dynamic-component-editor/options/poster";
import SingleVideo from "%/dynamic-component-editor/options/single-video";
import Loop from "%/dynamic-component-editor/options/loop";
import BorderOptions from "%/dynamic-component-editor/bundles/border-options";
import BorderColor from "%/dynamic-component-editor/options/border-color";
import BorderWidth from "%/dynamic-component-editor/options/border-width";
import BorderRadius from "%/dynamic-component-editor/options/border-radius";
import LayoutWidthHeightOptions from "%/dynamic-component-editor/bundles/layout-width-height-options";
import LayoutHeight from "%/dynamic-component-editor/options/layout-height";
import LayoutWidth from "%/dynamic-component-editor/options/layout-width";
import AppearanceOptions from "%/dynamic-component-editor/bundles/appearance-options";
import BorderSides from "%/dynamic-component-editor/options/border-sides";
import EffectsOptions from "%/dynamic-component-editor/bundles/effects-options";
import BoxShadow from "%/dynamic-component-editor/options/box-shadow";
import BaseOption from "%/dynamic-component-editor/classes/base-option";
import MinHeight from "%/dynamic-component-editor/options/min-height";
import MaxHeight from "%/dynamic-component-editor/options/max-height";
import MinWidth from "%/dynamic-component-editor/options/min-width";
import MaxWidth from "%/dynamic-component-editor/options/max-width";
import AnimationEffectsOptions from "%/dynamic-component-editor/bundles/animation-effects-options";
import ClickAction from "%/dynamic-component-editor/options/click-action";
import { GestureActionsMixin } from "%/dynamic-component-editor/standard-elements/click-actions/gesture-actions-mixin";
import { OptionMediaResolverMixin } from "%/dynamic-component-editor/mixins/option-media-resolver-mixin";

export const SingleVideoElementMixin = {
  mixins: [OptionMediaResolverMixin, GestureActionsMixin],
  elementPanelSettings: {
    displayIcon: "video",
    elementType: "element",
  },
  optionBundles: [
    new LayoutWidthHeightOptions({
      "default.layout-width": 300,
    }),
    new AppearanceOptions({}, {
      "border-radius": false,
    }),
    VideoOptions,
    BorderOptions,
    new EffectsOptions({}, {
      "text-shadow": true,
    }),
    AnimationEffectsOptions,
  ],
  options: [
    ClickAction,
  ],
  data() {
    return {
      ClickAction,
      SingleVideo,
      Autoplay,
      Loop,
      Controls,
      Muted,
      Poster,
      LayoutWidth,
      MinWidth,
      MaxWidth,
      LayoutHeight,
      MinHeight,
      MaxHeight,
      BorderColor,
      BorderWidth,
      BorderRadius,
    };
  },
  methods: {
    // Every video variant hands the same player over, so a media behaviour
    // cannot depend on which twin happened to render.
    gestureMedia() {
      return this.$refs.video ?? null;
    },
  },
  computed: {
    // Source + poster are stored either as a media_id (resolved to a fresh
    // playback URL at render) or a legacy URL (used directly).
    videoSrc() {
      return this.resolveOptionMedia(this.getOptionValue(SingleVideo));
    },
    posterSrc() {
      return this.resolveOptionMedia(this.getOptionValue(Poster));
    },
    myBorderRadius() {
      return this.getOptionValue(BorderRadius);
    },
    myBorderSides() {
      return this.getOptionValue(BorderSides);
    },
    videoStyleOverrides() {
      return {
        borderRadius: this.myBorderRadius,
        boxShadow: this.getOptionValue(BoxShadow),
        boxShadowHover: this.getOptionValue(BoxShadow, BaseOption.$states.HOVER),
      };
    },
  },
};
